module.exports = __webpack_public_path__ + "media/images/undraw_color_palette_yamk-9f59b6bf490ca346b8f30d177309f75e.svg";